import React from 'react';
import { ReferralButton } from './ReferralButton';
import { Reveal } from './Reveal';
export function FinalCta() {
  return <section className="relative overflow-hidden bg-base px-5 py-32 lg:px-8 lg:py-44" data-id="element-49" data-mp="vghfhjugu3md">
      <div className="pointer-events-none absolute left-1/2 top-1/2 h-[560px] w-[900px] -translate-x-1/2 -translate-y-1/2" style={{
      background: 'radial-gradient(45% 45% at 50% 50%, rgba(247,162,59,0.26), rgba(5,5,5,0) 72%)'
    }} aria-hidden="true" data-id="element-50" data-mp="19g0b5d63bmhs" />
      <div className="hairline-grid pointer-events-none absolute inset-0 opacity-40 [mask-image:radial-gradient(55%_55%_at_50%_50%,#000,transparent)]" data-id="element-51" data-mp="1ed8yds63igpw" />

      <div className="relative mx-auto max-w-shell text-center" data-id="element-52" data-mp="1o43lszv2vmcx">
        <Reveal data-id="element-53" data-mp="1o4n0m7pflumq">
          <h2 className="mx-auto max-w-[860px] text-[34px] font-extrabold uppercase leading-[0.96] tracking-tightest text-white sm:text-[56px]" data-id="element-54" data-mp="1o67pphsz8ld7">
            Descubre el mundo crypto desde un solo lugar.
          </h2>
          <p className="mx-auto mt-6 max-w-[480px] text-[15px] leading-relaxed text-ink-muted" data-id="element-55" data-mp="n5ujxwb6dde4">
            Crea tu cuenta y explora las herramientas disponibles en Bybit.
          </p>
          <ReferralButton location="final_cta" size="lg" showArrow className="mt-10 !h-16 !px-10 !text-base" data-id="element-56" data-mp="x3s86jt1ba6q">
            Crear mi cuenta
          </ReferralButton>
          <p className="mx-auto mt-6 max-w-[420px] text-[11.5px] leading-relaxed text-white/35" data-id="element-57" data-mp="1246gm2yjsm5a">
            El trading de criptomonedas implica riesgos y puede no ser adecuado para todos los
            inversores.
          </p>
        </Reveal>
      </div>
    </section>;
}